export interface PaymentReference {
  refKey: string;
  refValue: string[];
}

export interface Payment {
  paymentUuid: string;
  customerUuid: string;
  paymentStatus: string;
  paymentType: string;
  createdDate: string;
  references: PaymentReference[];
}

export interface CommunityPaymentsResponse {
  paymentAmounts?: Record<string, number>;
  payments: Payment[];
}

export interface RegularPaymentsResponse {
  paymentStatus: string;
}

export enum PaymentType {
  ApplicationFee = "ApplicationFee",
  SecurityDeposit = "SecurityDeposit",
  IncreasedSecurityDeposit = "IncreasedSecurityDeposit",
}

export enum PaymentStatus {
  Initialized = "Initialized",
  Submitted = "Submitted",
  Accepted = "Accepted",
  Declined = "Declined",
  Failed = "Failed",
  Returned = "Returned",
  NSF = "NSF",
  Cancelled = "Cancelled",
  Error = "Error",
}
